// extracted by mini-css-extract-plugin
module.exports = {"header":"Table_header__XR9PO","footer":"Table_footer__BpBLY"};